module.exports = __webpack_public_path__ + "img/banner-1.76e4d4e1.jpg";